import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UiActions } from './ui.actions';
import { UsersService } from '../../services/users/users.service';
import { CommonService } from 'app/services/common/common.service';

export const loadNavigation$ = createEffect(
    (actions$ = inject(Actions), usersService = inject(UsersService)) =>
        actions$.pipe(
            ofType(UiActions.loadNavigation),
            switchMap(({ userId }) =>
                usersService.getNavigationByUser(userId).pipe(
                    map((res: any) => {
                        let leftNav = res?.data?.leftNav ?? [];
                        let rightNav = res?.data?.rightNav ?? [];
                        const searchBoxVisible = res?.data?.hasSearchPermission ?? false;
                        if (rightNav.length > 0) {
                            rightNav = rightNav.filter((nav: any) =>
                                nav.id !== 'Notifications' && nav.id !== 'recruiter Dashboard'
                            );
                        }
                        return UiActions.loadNavigationSuccess({ leftNav, rightNav, searchBoxVisible });
                    }),
                    catchError(err => of(UiActions.loadNavigationFailure({
                        error: err?.error?.message ?? 'Failed to load navigation'
                    })))
                )
            )
        ),
    { functional: true }
);

export const loadReleaseInfo$ = createEffect(
    (actions$ = inject(Actions), commonService = inject(CommonService)) =>
        actions$.pipe(
            ofType(UiActions.loadReleaseInfo),
            switchMap(() =>
                commonService.getSystemReleaseInfo().pipe(
                    map((res: any) => UiActions.loadReleaseInfoSuccess({
                        buildNumber: res.data?.buildNumber ?? '',
                        buildDate: res.data?.buildDate ?? '',
                        versionNumber: res.data?.versionNumber ?? '',
                    })),
                    catchError(err => of(UiActions.loadReleaseInfoFailure({
                        error: err?.error?.message ?? 'Failed to load release info'
                    })))
                )
            )
        ),
    { functional: true }
);
